module.exports = __webpack_public_path__ + "img/05.92ff9304.png";